// Multivariate Dependencies
import React from 'react';
// Components
import { FaCheck } from 'react-icons/fa';
import { ImMinus } from 'react-icons/im';
/**
 * @description Returns the icon to show in the checkbox depending on the check and indeterminate flag.
 *
 * @param {boolean} checked If the checkbox is checked
 * @param {boolean} [indeterminate=false] Visually overrides checked but has no functional
 *                                        meaning. This returns its own icon
 * @return {JSX.Element | null} An icon
 */
export var getCheckboxIcon = function (checked, indeterminate) {
    if (indeterminate === void 0) { indeterminate = false; }
    switch (true) {
        case indeterminate:
            return React.createElement(ImMinus, null);
        case checked:
            return React.createElement(FaCheck, null);
        default:
            return null;
    }
};
//# sourceMappingURL=getCheckboxIcon.js.map